module.exports = __webpack_public_path__ + "img/flight-academy-thumb.b621e8ea.png";